module.exports = __webpack_public_path__ + "zilky-v-obliceji_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/zilky-v-obliceji_1_after_tn.jpg
// module id = 1461
// module chunks = 0